import { CartProduct } from '../model/cart'
import {
  CartFilters,
  FilterCounters,
  FilterData,
  PlpFilters,
  WishlistFilters,
} from '../model/filters'
import { Product } from '../model/product'
import { CheckoutFilters } from '../model/checkout'
import { WishlistProduct } from '../model/wishlist'

const facetsWorker = new Worker('./calculate-cart-facets.worker', { type: 'module' })

// Wishlist products are accepted too: the calculation only relies on the
// identity fields they share with cart products (modelCode / mocoCode /
// colorCode / upc), while cart-only properties simply resolve to undefined (RED-8321).
export function requestCalculateFacetsFromCart(
  cartProducts: (CartProduct | WishlistProduct)[],
  cartProductsDetails: Record<string, Product>,
  filters: FilterData | CheckoutFilters,
  releases?: string[],
) {
  return new Promise<
    {
      name: keyof (PlpFilters | CartFilters | WishlistFilters | CheckoutFilters)
      options: FilterCounters
    }[]
  >(res => {
    let requestId: string | undefined = undefined
    const cb = (e: {
      data: {
        requestId: string
        response: {
          name: keyof (PlpFilters | CartFilters | WishlistFilters | CheckoutFilters)
          options: FilterCounters
        }[]
      }
    }) => {
      if (e.data.requestId === requestId) {
        facetsWorker.removeEventListener('message', cb)
        res(e.data.response)
      }
    }
    facetsWorker.addEventListener('message', cb)
    requestId = (Date.now() + Math.random()).toString()
    facetsWorker.postMessage({ cartProducts, cartProductsDetails, filters, releases, requestId })
  })
}
